var map = {
	"./frame-card-chieftain.png": 420,
	"./frame-card-elder.png": 421,
	"./frame-card-grandchief.png": 422,
	"./frame-card-highchief.png": 423,
	"./frame-card-overseer.png": 424,
	"./frame-card-warchief.png": 425,
	"./frame-card-warlord.png": 426,
	"./frame-card-warmonger.png": 427,
	"./frame-card-warrior.png": 428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1048;